import React, { ReactNode } from 'react';
import clsx from "clsx";
import { BaseCard } from "../../../components/BaseCard";
import Typography from "../../../components/Typography";


/** Combined data type */
export type DataReport = {
    data: Record<string, Record<string, number>>;
    groupings: string[];
};

export interface BaseDataChartProps {
    title: string;
    data: DataReport;
    className?: string;
    height?: number;
    width?: number;
    loading?: boolean;
}

interface Props extends BaseDataChartProps {
    children: ReactNode;
    footer?: ReactNode;
}

const BaseDataChart: React.FC<Props> = ({
                                            title,
                                            data,
                                            children,
                                            footer,
                                            className,
                                            height = 380,
                                            width = 520,
                                            loading = false,
                                        }) => {
    return (
        <BaseCard
            hoverable={false}
            className={clsx('p-5 relative overflow-hidden flex flex-col', className)}
            style={{ height: `${height}px`, width: `${width}px` }}
        >
            {/* Header - Fixed */}
            <div className="mb-4">
                <Typography variant="subtitle2" loading={loading}>
                    {title}
                </Typography>
            </div>

            {/* Chart Area - Flexible */}
            <div className="flex-1 flex items-center justify-center min-h-0">
                {children}
            </div>

            {/* Footer - Fixed (optional) */}
            {footer && (
                <div className="mt-4 pt-3 border-t">
                    {footer}
                </div>
            )}
        </BaseCard>
    );
};

export default BaseDataChart;